<script>
  import {getContext, onMount} from 'svelte';
  import QRCode from 'qrcode';
  import {sd} from '@/da';
  import {Button} from '@px/button';
  import {goto} from '@sapper/app';
  import {PATHS} from '@/const/paths';
  import {envUtil} from '@/helper/env';
  import {fixLink$} from '@/store/lang';
  import SkeletonLoginView from '@/widgets/skeleton/LoginView.svelte';
  import Skeleton from '@/widgets/skeleton/Skeleton.svelte';
  import {openDepositDrawer} from '@/modules/components/deposit/utils';
  import PreheatEntryText from '@/modules/homepage/components/PreheatEntryText.svelte';
  import {IMAGES} from '../images';
  import SignUpWithEmail from './SignUpWithEmail.svelte';
  import homeLang from '@/modules/home/HomePage.lang.js';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  let account = '';
  let qrcodeUrl = '';

  onMount(async () => {
    const href = window.location.origin + PATHS.DOWNLOAD.pathname;
    qrcodeUrl = await QRCode.toDataURL(href);
  });

  function handleClickTrade() {
    goto('/trade/BTCUSDT');
  }

  function handleClickDeposit() {
    sd.track('web_click', {$screen_name: 'home', $element_content: 'deposit'});
    openDepositDrawer({LG});
  }

  function handleBannerClick() {
    goto($fixLink$(PATHS.WEB3_SOCIAL_TRADE_EXPLORE_GROUPS.pathname))
  }
</script>

<style>
  .wrap {
    margin-top: -80px;
    background: #000;
  }

  .main {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 120px 0 32px;
    width: 1200px;
  }

  .subtitle {
    margin-bottom: 28px;
    font-size: 20px;
    letter-spacing: 1px;
  }

  .title {
    margin-top: 28px;
    margin-bottom: 30px;
    width: 640px;
    line-height: 72px;
    font-size: 52px;
  }

  .trade-deposit {
    width: 420px;
  }

  .register :global(button),
  .trade-deposit :global(button) {
    height: 64px;
  }

  .trade-deposit :global(button.default) {
    border: 1px solid #dbdfe7;
    background: transparent;
    color: var(--TW);
  }

  .trade-deposit :global(button.default:hover) {
    border: none;
    background: var(--blue);
  }

  .download-content {
    margin-bottom: 32px;
    margin-left: 20px;
    width: 178px;
  }

  .qr-code:hover > div {
    display: block;
  }

  .qr-code > div {
    display: none;
    border: 1px solid #303030;
    padding: 8px;
    background: #1f1f1f;
    /* -28 = 80/2 + 8 - 40/2 */
    transform: translate(-28px, 4px);
  }

  .qr-code > div:before {
    position: absolute;
    top: -12px;
    left: 50%;
    border: 6px solid;
    border-color: transparent transparent #1f1f1f transparent;
    transform: translateX(-6px);
    content: '';
  }

  .banner-left {
    margin-bottom: 10px;
  }

  .banner-right {
    align-items: flex-end;
  }

  .video {
    object-fit: cover;
  }

  @media screen and (max-width: 640px) {
    .wrap {
      margin-top: 0;
    }

    .video {
      display: none;
    }

    .main {
      padding: 140px 20px 40px;
      width: 100%;
    }

    .subtitle {
      margin-bottom: 16px;
      font-size: 16px;
    }

    .title {
      margin-top: 20px;
      margin-bottom: 20px;
      width: 100%;
      line-height: 28px;
      font-size: 20px;
    }

    .m-mask {
      margin-bottom: 0;
    }

    .m-mask:after {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100px;
      background: linear-gradient(transparent, #000);
      content: '';
    }

    .banner-right {
      display: none;
    }

    .trade-deposit {
      width: 100%;
    }
  }
</style>

<section class="wrap TW cp" on:click={handleBannerClick}>
  <div class="main pr df aic jcsb">
    <div class="banner-left">
      <div class="subtitle">{LG(lang.BreakThrough)} {LG(lang.BreakFree)}</div>
      <h1 class="title">{@html LG(lang.TheMostEfficient, {Efficient: "<span style='color:#53FF00'>" + LG(lang.Efficient) + '</span>'})}</h1>
      <SkeletonLoginView height="112px">
        <svelte:fragment slot="init">
          <div class="trade-deposit df aic">
            <Skeleton height="64px" colorMode="black" />
            <Skeleton height="64px" colorMode="black" class="ml20" />
          </div>
        </svelte:fragment>
        <svelte:fragment slot="login">
          {#if envUtil.isMobile}
            <div class="m-mask pr tc">
              <img width="148" height="200" src={IMAGES.BANNER_LOGIN_MOBILE} alt="kevin" />
            </div>
          {/if}
          <div class="trade-deposit df aic" on:click|stopPropagation>
            <Button type="primary" size="large" block on:click={handleClickTrade}>
              <span class='fw3'>{LG(lang.Trade)}</span>
            </Button>
            <Button class="ml20" type="default" block size="large" on:click={handleClickDeposit}>
              <span class='fw3'>{LG(lang.Deposit)}</span>
            </Button>
          </div>
        </svelte:fragment>
        <svelte:fragment slot="logout">
          {#if envUtil.isMobile}
            <div class="m-logout-logo df jcsb">
              <div class="f1 f12">
                <div class="mb12 f14">{LG(lang.PhemexBrandAmbassador)}</div>
                <div class="mb12">{LG(lang.KevinSay)}</div>
                <div>-{LG(lang.Kevin)}</div>
              </div>
            </div>
          {/if}
          <div class="register df fdc">
            <div class="df aic mt12 mb12">
              <img class="mr4" width="24" height="24" src={IMAGES.GIFT} alt="bonus" />
              <div>
                {@html LG(homeLang.NewUserBonus, {Volume: `<span style='color:#53FF00'>$8,800</span>`})}
              </div>
            </div>
            <div class="df aic">
              <SignUpWithEmail />
            </div>
          </div>
        </svelte:fragment>
      </SkeletonLoginView>
    </div>
    <a class="banner-right" href={$fixLink$(PATHS.WEB3_SOCIAL_TRADE_EXPLORE_GROUPS.pathname)}>
      <img class="db mr30" width="468" height="374" src="https://img.phemex.com/v1/0e0ff3ac-2022-4a91-b2ab-52a0ce386a05/pluse-cast-banner.png" alt="Lending Protocol">
      <PreheatEntryText />
    </a>
  </div>
</section>
